const renewalDetailsFormatter = (data, renewalData) => {

  const dataSet = data;
  dataSet["id"] = renewalData?.pand_id
  return dataSet;
};

  export default renewalDetailsFormatter;
  